<template>
  <span
    v-if="presentation.pillClass"
    class="badge"
    :class="presentation.pillClass"
  >
    {{ t(presentation.key) }}
  </span>
  <span v-else>{{ t(presentation.key) }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import {
  displayStatusPresentation,
  type OrderDisplayStatus,
} from "./orderDisplayStatus";

const props = defineProps<{
  /** An order's `displayStatus`, or a status filter option. */
  status: OrderDisplayStatus;
}>();

const { t } = useI18n();

const presentation = computed(() => displayStatusPresentation(props.status));
</script>
